import React, { FC } from 'react';
import Stack, { StackProps } from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { ArrowRightIcon as SvgArrowRightIcon } from 'src/shared/components/icons';
import { isSameDay } from 'src/shared/utils';

import { useAbsenceDates } from './hooks';

export const AbsenceDates: FC<{
  startDate: string;
  endDate: string;
  startTime: string | null | undefined;
  endTime: string | null | undefined;
  sx?: StackProps['sx'];
  className?: string;
}> = ({ sx, className, ...props }) => {
  const { startDate, endDate, startTime, endTime } = useAbsenceDates({
    rawStartDate: props.startDate,
    rawEndDate: props.endDate,
    rawStartTime: props.startTime,
    rawEndTime: props.endTime,
  });

  if (startTime) {
    return (
      <AbsenceInfoContainer className={className} direction="row" sx={sx} justifyContent="flex-start">
        <Typography sx={{ fontSize: 'inherit' }}>{startDate}</Typography>
        <Typography sx={{ fontSize: 'inherit', marginLeft: '0.5rem' }}>
          {startTime} - {endTime}
        </Typography>
      </AbsenceInfoContainer>
    );
  }

  if (isSameDay(startDate, endDate)) {
    return (
      <AbsenceInfoContainer className={className} sx={sx}>
        <Typography sx={{ fontSize: 'inherit', width: '100%' }}>{startDate}</Typography>
      </AbsenceInfoContainer>
    );
  }

  return (
    <AbsenceInfoContainer className={className} direction="row" sx={sx} alignItems="center" justifyContent="flex-start">
      <Typography sx={{ fontSize: 'inherit' }}>{startDate}</Typography>
      <ArrowRightIcon size={16} />
      <Typography sx={{ fontSize: 'inherit' }}>{endDate}</Typography>
    </AbsenceInfoContainer>
  );
};

const AbsenceInfoContainer = styled(Stack)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.text.primary,
}));

const ArrowRightIcon = styled(SvgArrowRightIcon)(() => ({
  margin: '0 0.5rem',
}));
